module.exports = __webpack_public_path__ + "static/media/gif.884a4083.gif";